import { selectPromoIds } from './promoIds';
import { IApplicationState } from '../../types/redux';

export const selectIsEmptyPromoIds = (state: IApplicationState) => {
  const promoIds = selectPromoIds(state);

  return promoIds.length === 0;
};
